<template>
	<div>
		<h1>{{ptype}}</h1>
		<div>
			<table class="table" v-if="loaded">
				<tr>
					<td>
						<b-dropdown v-if="isOwner && possibleTransitions.length" id="dropdown-right" right text="Change Status" variant="primary" class="m-2">
							<b-dropdown-item v-for="trans in possibleTransitions" v-bind:key="trans.status" href="#" @click="changeStatus(trans.status)">{{trans.name}}</b-dropdown-item>
						</b-dropdown>
						<b-button v-if="isOwner && loaded" variant="warning" v-b-modal.new-offer-modal>Edit</b-button>
					</td>
					<td></td>
				</tr>
				<b-modal  v-if="isOwner && loaded" id="new-offer-modal" :title="'Edit'+ptype" okTitleHtml="Update">
					<ProjectCreateEditWidget :project="project" :mode="'edit'"></ProjectCreateEditWidget>
				</b-modal>
		
				<tr><td>Title</td><td>{{project.title}}</td></tr>
				<tr><td>Description</td><td><pre>{{project.description}}</pre></td></tr>
				<tr v-if="project.deadline"><td>Deadline</td><td>{{project.deadline}}</td></tr>
				<tr v-if="project.isMember && project.trackerURL"><td>Tracker URL</td><td><a class="underlineHover" target="_new" :href="project.trackerURL">Open</a></td></tr>
				<tr v-if="project.isMember && project.chatURL"><td>Chat URL</td><td><a class="underlineHover" target="_new" :href="project.chatURL">Open</a></td></tr>
				<tr v-if="project.isMember && project.storageURL"><td>Files URL</td><td><a class="underlineHover" target="_new" :href="project.storageURL">Open</a></td></tr>
				<tr>
					<td><div>Participants</div>
						<b-button v-if="isOwner && loaded" variant="success" @click="createInvite">Invite Participant</b-button>
					</td>
					<td><ul>
							<li v-for="role in project.roles" v-bind:key="role.user.id">
								<a class="underlineHover" :href="$router.resolve('/profile/'+role.user.id).href" onclick="return false;" @click="showProfile(role.user.id);">{{role.user.name}} | {{role.role}}</a>
							</li>
						</ul>
					</td></tr>
				<tr><td>Created at</td><td>{{ new Date(project.created) | moment("dddd, MMMM Do YYYY") }}</td></tr>
				<tr><td>By</td><td><a class="underlineHover" :href="$router.resolve('/profile/'+project.owner.id).href" onclick="return false;" @click="showProfile(project.owner.id)">{{ project.owner.name }}</a></td></tr>
				<tr v-if="invite"><td colspan="2"><b-button variant="primary" @click="joinProject">Join Project</b-button></td></tr>
				<tr v-if="project.isMember">
					<td>Notes</td>
					<td>
						<a v-if="!showNotes" class="underlineHover" href="#" onclick="return false;" @click="toggleNotes()">View Notes ({{project.notes}})</a>
						<a v-if="showNotes" class="underlineHover" href="#" onclick="return false;" @click="toggleNotes()">Hide Notes</a>
					</td>
				</tr>
				<tr>
					<td colspan="2" v-if="showNotes"><NotesWidget :projectID="project.id"></NotesWidget></td>
				</tr>
			</table>
		</div>
		<b-modal id="modal-1" title="Invintation" okOnly>
			<div class="container">
				<input type="text" v-model="newInviteURL" :disabled="linkDisplay" ref="linkDisplay">
				<div v-if="linkCopied">Copied to clipboard!</div>
				<button v-if="!linkCopied" type="button" @click="onCopy">Copy!</button>
			</div>
		</b-modal>
		<b-modal id="profile-modal" :title="quickUser.name" okOnly>
			<ProfileWidget :user="quickUser"></ProfileWidget>
		</b-modal>
	</div>
</template>
<script>
import ProfileWidget from './ProfileWidget.vue'
import ProjectCreateEditWidget from './ProjectCreateEditWidget.vue'
import NotesWidget from './NotesWidget.vue'

export default {
	name: 'ProjectPage',
	data(){
		return {
			loaded:false,
			ptype:"",
			project:{},
			invite:"",
			isOwner:false,
			newInviteURL:"",
			quickUser:{},
			linkCopied:false,
			linkDisplay:true,
			possibleTransitions:[],
			showNotes:false
		}
	},
	components:{
		ProfileWidget,
		ProjectCreateEditWidget,
		NotesWidget
	},
	mounted(){
		if(!this.$API.loggedIn){
			this.$router.push("/login?redirect=" + this.$route.path)
			return;
		}
		this.loadProject();
	},
	methods:
	{
		show(){
			this.loaded=true;
			this.$API.title="Project | " + this.project.title;
		},
		loadProject(){
			this.invite="";
			this.isOwner=false;
		if("id" in this.$route.params){
			this.$API.title="Loading Project...";
			this.$API.apiGET("/projects?id="+this.$route.params.id, true).then((response)=>{
				this.processData(response);
			});
		}else if("invite" in this.$route.params){
			this.invite=this.$route.params.invite;
			this.$API.title="Loading Project...";
			this.$API.apiGET("/projects?invite="+this.invite, true).then((response)=>{
				this.processData(response);
			});
		}else
			this.$router.push("/404");
		},
		processData(data){
			if(data.status=="fail"){
				this.$router.push("/404");
				return;
			}
			this.possibleTransitions=[];
			this.project=data.project;
			if(this.project.owner.id==this.$API.user.id)
				this.isOwner=true;
			switch(this.project.status){
				case "new":
					this.ptype="Offer";
					this.possibleTransitions=[{name:"Start working!",status:"in_progress"},{name:"Cancel Offer",status:"cancelled"}];
					break;
				case "in_progress":
					this.ptype="Active | In Progress";
					this.possibleTransitions=[{name:"Review Project",status:"in_review"},{name:"Pause Project",status:"on_hold"},{name:"Cancel Project",status:"cancelled"}];
					break;
				case "in_review":
					this.ptype="Active | In Review";
					this.possibleTransitions=[{name:"Back To Work!",status:"in_progress"},{name:"Pause Project",status:"on_hold"},{name:"Work Complete!",status:"done"},{name:"Cancel Project",status:"cancelled"}];
					break;
				case "on_hold":
					this.ptype="Active | On Hold";
					this.possibleTransitions=[{name:"Back To Work!",status:"in_progress"},{name:"Cancel Project",status:"cancelled"}];
					break;
				case "done":
					this.ptype="Finished";
					break;
				case "cancelled":
					this.ptype="Cancelled";
					break;
				default:break;
			}
			this.show();
		},
		joinProject(){
			this.$API.apiPOST("/projects/join", {"invite":this.invite}, true).then((response)=>{
				if(response.status=="success")
					this.$router.push("/project/"+this.project.id);
			});
		},
		createInvite(){
			this.$API.apiGET("/projects/invite?id="+this.project.id, true).then((response)=>{
				this.newInviteURL=window.location.origin+"/join/"+response.invite;
				this.linkCopied=false;
				this.$bvModal.show("modal-1");
			});
		},
		onCopy(){
			this.linkDisplay=true;
			this.$refs.linkDisplay.select();
			document.execCommand("copy");
			this.linkDisplay=true;
			this.linkCopied=true;
		},
		showProfile(id){
			this.$API.loadProfile(id).then((response)=>{
				this.quickUser=response.profile;
				this.$bvModal.show("profile-modal");
			})
		},
		changeStatus(status){
			this.$API.apiPOST("/projects/status", {status:status, id:this.project.id}, true).then((response)=>{
				if(response.status=="success")
					this.loadProject();
			});
		},
		toggleNotes(){
			this.showNotes=!this.showNotes;
		},
	},
	watch:
	{
		'$route' () {
			this.loaded=false;
			this.loadProject();
		},
		'$API.user'(){
			if(this.$API.user && this.project.owner)
				this.isOwner=this.project.owner.id==this.$API.user.id
			else
				this.isOwner=false;
		}
	}
}
</script>
<style type="text/css" scoped>
	#dropdown-right{
		margin: 0px 5px 0px 0px !important;
	}
</style>